'use strict';

bbw.directive.bbwSubmit = ['bbw.OffsetCalcSvc', '$rootScope', function(offsetCalc, $rootScope) {
    return {
        restrict: 'A',
        link: function(scope, element, attributes) {
            attributes.$set('novalidate', 'novalidate');
            var submitForm = function(e) {
                e && e.preventDefault && e.preventDefault();
                angular.forEach(element[0].querySelectorAll('.ng-pristine'), function(el) {
                    angular.element(el).removeClass('ng-pristine');
                });
                $rootScope.$safeApply(function() {
                    var form = scope[attributes.name];
                    angular.forEach(form, function($el, name) {
                        if (name.substr(0, 1) === '$') {
                            return;
                        }
                        $el.$pristine = false;
                        $el.$dirty = true;
                        $el.$touched = true;
                    });

                    if (form.$invalid) {
                        var invalidElements = element[0].querySelectorAll('.ng-invalid');
                        for (var i = 0; i < invalidElements.length; ++i) {
                            var elm = invalidElements[i];
                            if (elm.tagName !== 'FORM' && elm.form) {
                                elm.focus();
                                break;
                            }
                        }
                        scope.$broadcast('valdr-revalidate');
                        setTimeout(function() {
                            var errEl = element[0].querySelector('.ng-invalid');
                            if (errEl) {
                                var top = offsetCalc.top(errEl);
                                window.scrollTo(0, top - window.innerHeight / 2);
                            } else {
                                window.scrollTo(0, 0);
                            }
                        }, 50);
                        $rootScope.$safeApply();
                        return false;
                    }
                    $rootScope.$safeApply(function() {
                        scope.$eval(attributes.bbwSubmit);
                    });
                });
            };
            element.bind('submit', function(e) {
                submitForm(e);
            });
            scope.$on('submit-form', function(e, a) {
                if (a.form && a.form.$name === element[0].name) {
                    submitForm();
                }
            });
        }
    };
}];
